export const MILLISECONDS = 'milliseconds';
export const SECONDS = 'seconds';
export const MINUTES = 'minutes';
export const HOURS = 'hours';
export const DAYS = 'days';
export const YEARS = 'years';